/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Manager_New_Guide_CreatedInputs */



/**
* | output |
* | --- |
* | "New KNP guide created" |
*
* @param {Knp_Manager_New_Guide_CreatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_new_guide_created = /** @type {((inputs?: Knp_Manager_New_Guide_CreatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_New_Guide_CreatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouveau guide KNP créé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neuer KNP-Führer erstellt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Creata la nuova guida KNP")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создан новый путеводитель по КНП.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nueva guía del KNP creada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新版克鲁格国家公园指南已编写完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいKNPガイドが作成されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केएनपी के लिए नई गाइड बनाई गई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Novo guia do KNP criado")
	return /** @type {LocalizedString} */ ("New KNP guide created")
});